<template>
  <div class="dailylist_box border_box">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finished_text"
      @load="onLoad"
    >
      <a class="daily_item border_box" v-for="(item,i) of list" :key="i" @click="tzdailyanalysis(item)">
        <div class="daily_log border_box flex_v_center">
          <div class="flex_verticle">
            <span class="rpoet_icon" :class="{weekly_icon:reportType === 2, monthly_icon:reportType === 3}"></span>
            <span class="daily_txt">{{item.reportName}}</span>
          </div>
          <span class="arrow_icon"></span>
        </div>
      </a>
    </van-list>
    <div class="nodata_box border_box" v-show="nodate">无数据</div>
  </div>
</template>
<script>
  import {getDailyReportList} from '@/api/reportlist'
  import { wxShare } from '@/helpers/wxconfig'
  let moment = require("moment");
  import { List } from 'vant';
  export default {
    name: 'dailylist',
    data() {
      return {
        finished_text:"",
        nodate:false,
        listData:[],
        list: [],
        loading: false,
        finished: false,
        // reportType:1
        // dayReportMintime:this.$store.state.userInfo.dayReportMintime
      }
    },
    props:{
      reportType:{default:1}
    },
    components: {
      "van-list": List
    },
    methods: {
      // 查看报告
      tzdailyanalysis(record){
        var baseURL = 'http://push-admin-beta.istarshine.com'
        if (window.location.host === 'wechat.ewrwefg.com') {
          baseURL = 'http://push-admin.istarshine.com'
        }
        // const href = 'http://push-admin-beta.istarshine.com/#/briefView/briefView?id=70787&subAccount=4770&uuid=ba7935791ed14921b6419e1b5a0f7a2c'
        const href = `${baseURL}#/briefView/briefView?id=${record.id}&subAccount=${record.receiveId}&uuid=${record.uuid}`
        window.open(href, '_blank')
      },

      // 获取报告列表
      getlist(){
        let params = {
          openid: this.$store.state.userInfo.openid,
          reportType: this.reportType
        }
        getDailyReportList(params).then(({data})=>{
          if(data.status === 200){
            this.listData = data.list
            // console.log(this.listData);
            if(this.listData.length == 0){
              this.nodate = true;
            }else{
              let arr = this.listData.splice(0,20)
              this.list = JSON.parse(JSON.stringify(arr))
            }
            // console.log(this.listData);

            this.loading = false;
          }
        })
      },
      onLoad() {
        // 异步更新数据
        let userInfo = this.$store.state.userInfo
        // if((userInfo.code === '1001001' || !userInfo.code) && this.$store.state.path == 'nobind' || !this.$route.query.code){
        //   this.finished = true
        //   this.nodate = true
        //   this.loading = false;
        //   return
        // }
        if(!this.list.length && !this.nodate){
          this.getlist()
        }else{
          setTimeout(() => {
            if(this.listData.length >= 20){
              let arr = this.listData.splice(0,20)
              this.list = this.list.concat(JSON.parse(JSON.stringify(arr)))
            }else if(this.listData.length > 0 && this.listData.length < 20){
              this.list = this.list.concat(JSON.parse(JSON.stringify(this.listData)))
              this.listData = []
            }else{
              this.finished = true
              if(this.list.length > 0 && this.finished){
                this.finished_text = "没有更多了";
              }else{
                this.finished_text = "";
              }

            }
            // 加载状态结束
            this.loading = false;
          }, 500);
        }
      }
    },
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import url("../dailylist.css");
</style>
